module.exports = __webpack_public_path__ + "static/media/assassin.d64d3ffd.png";